import React from 'react';
// @ts-ignore
import styles from './LegendItem.module.scss';
import Text from '../../../../Components/Base/Text/Text';

export interface LegendItemScheme {
	title: string;
	color?: string;
	icon?: string;
}

interface Props {
	item: LegendItemScheme;
}

const LegendItem: React.FC<Props> = ({ item }) => {
	return (
		<div className={styles.wrapper}>
			{item.color && (
				<div
					className={styles.bullet}
					style={{ backgroundColor: item.color }}
				/>
			)}
			{item.icon && (
				<img className={styles.icon} src={item.icon} alt={item.title} />
			)}
			<Text tx={item.title} />
		</div>
	);
};

export default LegendItem;
